import Api from './api.service';

const ENDPOINT = 'parameters';

export default {
  get: () => Api.get(ENDPOINT),
  store: (parameters) => Api.post(ENDPOINT, { parameters }),
};
